module.exports = __webpack_public_path__ + "static/back-to-school-5b8eb8fe387476553f8834ed5f406bf9.png";